import { admin, superAdmin, superAdminDelete } from "utils/permissions";
import { Client } from "./_clientService";
import sessionHelper from "./sessionHelper";
import { getPlatforms } from "./platformService";
import { getBrands } from "./brandServices";
import { getOperators } from "./operatorService";
import { getClubs, getPositions } from "./playerCardService";
import { getCurrencies } from "./currencyService";
import { getCardBGs } from "./cardBGServices";

async function signIn({ email, password }: any) {
  const result = await new Client({
    path: "/user/login",
    payload: { email: email.trim(), password: password.trim() },
  }).post();

  sessionHelper.onSignIn({
    email: result?.data?.user?.email,
    role: result?.data?.user?.role,
    name: result?.data?.user?.username,
    sid: result?.data?.token,
    isActive: result?.data?.user?.isActive,
    id: result?.data?.user?.id,
    lastLogin: result?.data?.user?.lastLogin,
    requiresPasswordReset: result?.data?.user?.requiresPasswordReset,
  });

  // await onCreateSession();

  return {
    success: true,
    requiresPasswordReset: result?.data?.user?.requiresPasswordReset,
    email: result?.data?.user?.email,
  };
}

async function onCreateSession() {
  try {
    const ops: any[] = [
      new Client({ path: `/countries/list` }).get(),
      new Client({ path: `/misc/ovrFormula` }).get(),
      new Client({ path: `/misc/languages` }).get(),
      getCurrencies({
        pageNo: 1,
        pageSize: 10,
        skipPagination: true,
      }),
      getCardBGs({
        pageNo: 1,
        pageSize: 10,
        skipPagination: true,
        sortDir: "asc",
      }),
    ];

    if ([superAdminDelete, superAdmin, admin].includes(sessionHelper.role)) {
      let _ops = [
        getClubs({ skipPagination: true }),
        getPositions({ skipPagination: true }),
        getPlatforms({ skipPagination: true }),
        getOperators({ skipPagination: true }),
        getBrands({ skipPagination: true }),
      ];
      ops.push(..._ops);
    }

    const response = await Promise.all(ops).catch((err) => {
      throw err;
    });

    sessionHelper.onCreateSession({
      countries: response[0]?.data || [],
      ovrFormula: response[1]?.data || [],
      languages: response[2]?.data || [],
      currencies: response[3]?.data?.currencies || [],
      cardBgs: response[4]?.data || [],
      clubs: response[5]?.data || [],
      positions: response[6]?.data || [],
      platforms: response[7]?.data?.platforms || [],
      operators: response[8]?.data?.operators || [],
      brands: response[9]?.data?.brands || [],
    });
    return response;
  } catch (e) {
    signOut();
  }
}

async function restore() {
  if (!sessionHelper.isLoggedIn()) return { error: true };
  sessionHelper.setUserInfo();
  await onCreateSession();

  return { error: false };
}

function signOut() {
  localStorage.removeItem("userInfo");
  sessionHelper.onSignOut();
}

export { signIn, signOut, restore, onCreateSession };
